/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TextMessage
 */
export interface TextMessage {
    /**
     * 
     * @type {string}
     * @memberof TextMessage
     */
    message?: string;
}

/**
 * Check if a given object implements the TextMessage interface.
 */
export function instanceOfTextMessage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TextMessageFromJSON(json: any): TextMessage {
    return TextMessageFromJSONTyped(json, false);
}

export function TextMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function TextMessageToJSON(value?: TextMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

